<template>
    <layout>
        <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off"
                    method="post"
                    data-vv-scope="form"
                    @keyup.enter="beforeSaveItem"
                    @submit.prevent="beforeSaveItem">

                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <MapProperties
                        :moduleCode="moduleCode"
                        :readonlyFormItem="readonlyFormItem"
                        v-model.lazy="form.map"
                        name="map-properties"
                        v-validate="''"
                    />

                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        :showCancelButton="false"
                        @save="beforeSaveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`, true)"
                    >
                    </buttons-footer>
                </form>
            </div>
        </div>
    </layout>
</template>

<script>
import GeneralMixin from '../../mixin'

export default {
    mixins: [
        GeneralMixin
    ],
    components: {
        MapProperties: () => import(/* webpackChunkName: "map-properties" */ '@/app/shared/components/manage/ManageMapProperties'),
    },
    provide() {
        return {
            parentValidator: this.$validator,
        }
    },
    data() {
        const pageID = 'settings';
        return {
            pageID: pageID,
            pageTitle: `${pageID}.titles`,
            form: {
                map: {

                }
            },
        }
    },
    mounted() {
        this.loadItem(this.url.getConfig, false);
    },
    computed: {
        titleItem() {
            return this.configTitle + ' - ' + this.pageTitle;
        },
        readonlyFormItem() {
            return !this.canEdit;
        },
    },
    methods: {
        beforeSaveItem: function() {
            if(this.canEdit) {
                this.saveItem(null, [], {}, true);
            }
        },
    },
}
</script>
